// extracted by mini-css-extract-plugin
module.exports = {"center":"Old_index_center__17Pp4","container":"Old_index_container__2H_Pz","scroll":"Old_index_scroll__MBX6L","slideInUp":"Old_index_slideInUp__Cyt0w"};